const routes = [
    {
        path: '/checkins/feiraempreendedor/expositor/inscricao',
        name: 'ExpositoresFormularioExterno',
        component: () => import('./FormularioExterno.vue'),
    },
];

export default routes;
